import React, { Ref, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import clsx from 'clsx';
import BottomNav from '../components/BottomNav';
import { generateDeputyNews, generateNewsThumbnail } from '../utils/news';
import { useParams } from 'react-router-dom';

interface NewsContainerProps {
  title: string;
  content: React.ReactElement;
  activeNews: number;
  totalNews: number;
  handleClickThumbnail: (idx: number) => void;
  articleRef: Ref<HTMLDivElement>;
}

function NewsContainer({
  title,
  content,
  activeNews,
  totalNews,
  handleClickThumbnail,
  articleRef,
}: NewsContainerProps) {
  const { id } = useParams();
  const thumbnailConfig = generateNewsThumbnail(id);

  return (
    <div className="flex space-x-36 mb-16 text-white">
      <div
        className="pt-8 h-[calc(100vh-237px)] overflow-y-auto no-scrollbar"
        ref={articleRef}
      >
        <h1 className="text-title font-bold capitalize">{title}</h1>
        <article className="mt-28 !max-w-full text-base font-medium pr-64 text-white">
          {content}
        </article>
      </div>

      <div className="min-w-[380px] h-[calc(100vh-237px)] flex flex-col space-y-24 pr-12 overflow-y-auto custom-scrollbar">
        {Array(totalNews)
          .fill('')
          .map((_, idx) => (
            <div
              className="flex w-full justify-end z-[1] relative items-center"
              key={idx}
            >
              {activeNews === idx && (
                <div className="text-white opacity-50 text-[70px] mr-12 font-bold">
                  {activeNews < 9 ? `0${activeNews + 1}` : activeNews + 1}
                </div>
              )}
              <img
                src={thumbnailConfig[idx]}
                alt="thumbnail"
                className={clsx(
                  'h-auto cursor-pointer border-[3px] border-white',
                  {
                    'w-[210px]': activeNews !== idx,
                    'w-[255px]': activeNews === idx,
                  }
                )}
                onClick={() => handleClickThumbnail(idx)}
              />
            </div>
          ))}
      </div>
    </div>
  );
}

export default function AchievementPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [activeNews, setActiveNews] = useState(0);
  const newsConfig = generateDeputyNews(id, t);
  const articleRef = useRef<HTMLDivElement>(null);
  const thumbnailConfig = generateNewsThumbnail(id);
  console.log(thumbnailConfig[activeNews]);

  const articleScrollToTop = () => {
    if (articleRef.current) {
      articleRef.current.scrollTop = 0;
    }
  };

  const handleClickThumbnail = (idx: number) => {
    setActiveNews(idx);
    articleScrollToTop();
  };

  const handlePreviousNews = () => {
    setActiveNews(activeNews - 1);
    articleScrollToTop();
  };

  const handleNextNews = () => {
    setActiveNews(activeNews + 1);
    articleScrollToTop();
  };

  return (
    <div
      className="min-h-screen bg-cover bg-no-repeat pt-60 pb-40 px-60"
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, #002D4B 100%), url("${thumbnailConfig[activeNews]}")`,
      }}
    >
      <Header />
      <NewsContainer
        articleRef={articleRef}
        title={newsConfig[activeNews].title}
        content={newsConfig[activeNews].content}
        activeNews={activeNews}
        totalNews={newsConfig.length}
        handleClickThumbnail={handleClickThumbnail}
      />
      <BottomNav
        page={activeNews}
        totalPage={newsConfig.length}
        onClickPrev={handlePreviousNews}
        onClickNext={handleNextNews}
      />
    </div>
  );
}
